module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/brands_logo/microsoft-b38eb77012e76531139f2776e634d543.svg";